export enum FaultsHistoryDeviceFaultType {
  Unknown = 'Unknown',
  DeviceOffline = 'DeviceOffline',
  BatteryLow = 'BatteryLow',
  BatteryCritical = 'BatteryCritical',
  IS32UnitError = 'IS32UnitError',
  IS32LocalbusError = 'IS32LocalbusError',
  IS32Error = 'IS32Error',
}

export enum FaultsHistoryGatewayFaultType {
  Unknown = 'Unknown',
  GatewayOffline = 'GatewayOffline',
  ServiceOffline = 'ServiceOffline',
  PassiveGatewayOffline = 'PassiveGatewayOffline',
}

export enum FaultsHistorySystemFaultType {
  Unknown = 'Unknown',
  SystemOffline = 'SystemOffline',
  IS32EarthError = 'IS32EarthError',
  IS32PowerError = 'IS32PowerError',
  IS32BatteryError = 'IS32BatteryError',
  IS32CentralError = 'IS32CentralError',
  IS32SystemError = 'IS32SystemError',
  IS32AllAddressesTaken = 'IS32AllAddressesTaken',
  IPUnitConfigurationError = 'IPUnitConfigurationError',
  IPUnitHighFrequencyError = 'IPUnitHighFrequencyError',
  IPUnitLocalBusError = 'IPUnitLocalBusError',
  IPUnitWirelessG2Error = 'IPUnitWirelessG2Error',
  IPUnitWirelessG2InterferenceError = 'IPUnitWirelessG2InterferenceError',
}

export enum FaultsHistoryConnectorFaultType {
  Unknown = 'Unknown',
  ConnectorOffline = 'ConnectorOffline',
}
